// 3rd
import {
    mapActions,
    mapState
} from 'vuex';

// models
import Achievement from '../models/Achievement';

// components
import HeadingSection from '../components/HeadingSection';

export default {
    components: {
        HeadingSection,
    },
    methods: {
        ...mapActions([
            'setFilter',
        ]),
    },
    computed: {
        ...mapState([
            'filterAchievementTab',
        ]),
        achievements() {
            return Achievement.getAll();
        }
    }
};
